import dayjs from "dayjs";
import { OrderProductItem } from "./orderProductItem";

const SHIPPING_MODE_REGULAR = 'REGULAR';
const SHIPPING_MODE_EXPRESS = 'EXPRESS';
const SHIPPING_MODE_NATIONWIDE = 'NATIONWIDE';

const SHIPPING_PREORDER_RELATIVE = "PREORDER_RELATIVE";
const SHIPPING_PREORDER_FIXED = "PREORDER_FIXED";

export interface IOrderScheduleData {
    scheduleId: number;
    mode: string;
    dateTime?: string;
    deliveryFee?: number;
    pickingStatus?: string;
    preOrder?: string;
    productList?: OrderProductItem[];
    startDate?: string;
    displayGroupName?: string;
    preRelativeDay?: number;
    deliveryDate?: number;
    date_slot?: string;
    booking_hour?: string;
    expressFee?: string;
}


export interface IOrderSchedule extends IOrderScheduleData {
    isPreorder(): boolean
    formattedDateTime(): string
}

export class OrderSchedule implements IOrderSchedule {
    constructor(data: IOrderScheduleData) {
        this.scheduleId = data.scheduleId
        this.mode = data.mode
        this.productList = []
        this.deliveryFee = data.deliveryFee
        this.dateTime = data.dateTime
        this.pickingStatus = "pending"
        this.preOrder = data.preOrder
        this.date_slot = data.date_slot
        this.booking_hour = data.booking_hour
        this.expressFee = data.expressFee
    }

    scheduleId: number;
    mode: string;
    dateTime?: string;
    deliveryFee?: number | undefined;
    pickingStatus?: string | undefined;
    preOrder?: string;
    productList?: OrderProductItem[] = [];
    startDate?: string;
    displayGroupName?: string | undefined;
    preRelativeDay?: number | undefined;
    deliveryDate?: number | undefined;
    date_slot?: string;
    booking_hour?: string;
    expressFee?: string;

    isPreorder(): boolean {
        if (this.preOrder === null) {
            return false;
        }
        return true;
    }
    formattedDateTime(): string {
        if (this.dateTime === null) {
            return "";
        }

        const dateFormat = dayjs().format("d MMM yyyy");
        const timeFormat = dayjs().format("HH:mm");

        // switch (locale.languageCode) {
        //   case 'th':
        //     dateFormat = new DateFormat(locale);
        //     break;
        //   default:
        // }

        const date: string = dayjs().format("d MMM yyyy");
        const start: string = dayjs().format("HH:mm");
        const end: string = dayjs().add(1, "hour").format("HH:mm");
        return `${date}, ${start} - ${end}`;
    }
}